import { AppMessage } from './AppMessage';
import { Ref, InjectionKey } from 'vue';

export interface ValidationContext {
    errors: Map<string, string>;
    registerValidator: (key: string, validator: (key:string, validator:string) => void) => void;
    validators: Record<string, any>;
}

export const ValidationContextKey: InjectionKey<ValidationContext> = Symbol('ValidationContext');

export interface NotificationContext {
    message: Ref<AppMessage>;
    notify: (message: AppMessage) => void;
    clear: () => void;
}

export const NotificationContextKey: InjectionKey<NotificationContext> = Symbol('NotificationContext');